/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/

let baseURL = "";
let syncBaseUrl = "";

if (process.env.NODE_ENV === "development") {
  baseURL = "http://127.0.0.1:4567/telemed";
  syncBaseUrl = "http://127.0.0.1:4567/telemed";

  // api.advenio.app (production API)
  // baseURL = "https://api.advenio.app/telemed";
  // syncBaseUrl = "https://api.advenio.app/telemed";
} else if (process.env.NODE_ENV === "production") {
  // api.advenio.app
  baseURL = "https://api.advenio.app/telemed";
  syncBaseUrl = "https://api.advenio.app/telemed";
}
export { baseURL, syncBaseUrl };
